class FloatingButton {
  constructor(el) {
    this.btns = document.querySelectorAll('.' + el);
    this.footer = document.querySelector('.js-footer');
    if (!this.btns.length || !this.footer) return;
    this.observe();
  }

  observe() {
    const observer = new IntersectionObserver(
      ([entry]) => {
        this.btns.forEach((btn) => {
          btn.classList.toggle('is-hidden', entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(this.footer);
  }
}
